// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {get, map, startCase} from 'lodash';

// Components
import Icon from '../core/icon';
import TooltipTrigger from '../core/tooltip-trigger';

// Styles
import './flagged-metadata-indicator.scss';

function FlaggedMetadataIndicator({flaggedMetadata}) {
    const getTooltipProps = () => ({
        className: 'flagged-metadata-indicator--flagged-fields',
        tooltipRenderer: renderFlaggedFieldContent,
    });

    const renderFields = (issues) => map(issues, (issue, index) => <li key={index}>{startCase(issue.fieldName)}</li>);

    const renderFlaggedFieldContent = () => {
        const {issues} = flaggedMetadata;

        const fields = issues ? (
            <ul className="flagged-metadata-indicator--flagged-fields-overlay-list">{renderFields(issues)}</ul>
        ) : null;

        return (
            <section className="flagged-metadata-indicator--flagged-fields-overlay">
                <div className="flagged-metadata-indicator--flagged-fields-overlay-title">Flagged Fields</div>
                {fields}
            </section>
        );
    };

    return flaggedMetadata && get(flaggedMetadata, 'status') !== 'FIXED' ? (
        <Link
            className="table-with-sort--link"
            to={['/investigation/flagged-metadata', flaggedMetadata.flaggedMetadataId].join('/')}
        >
            <TooltipTrigger {...getTooltipProps()}>
                <Icon className="flagged-metadata-indicator--flagged-icon" fontType="fa" iconName="flag" />
            </TooltipTrigger>
        </Link>
    ) : null;
}

FlaggedMetadataIndicator.propTypes = {
    flaggedMetadata: PropTypes.object,
};

export default FlaggedMetadataIndicator;
